import { render } from "./TipoMoneda.vue?vue&type=template&id=64b9867a"
import script from "./TipoMoneda.vue?vue&type=script&lang=js"
export * from "./TipoMoneda.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__